export default __webpack_public_path__ + "static/media/pisína polysterikí.c03ad8b0.webp";